import React from 'react';
import HeroSection from "./HeroSection";
import Breadcrumb from "./Breadcrumb";
import Card from './Card';

function ContactInfo() {
  return (

    <div className='aboutInfo'>
    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        heading="Contact Us"
        backgroundImage="/img/contact.jpg"
      />

      {/* Breadcrumb Navigation */}
      <Breadcrumb current="Contact" />

      {/* Inline Styling */}
      <style>
        {`
          .hover-link {
            text-decoration: none;
            color: inherit;
          }
          .hover-link:hover {
            color: blue;
          }
          .map-container {
            width: 100%;
            height: 400px;
            margin-top: 20px;
          }
        `}
      </style>

      {/* Cards Section */}
      <div className="container services">
        <div className="card-cover">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-4 mb-2">
                <Card
                  title="Corporate Office"
                  img="company.png"
                  text={ <a href='https://maps.app.goo.gl/8QGGU4sMSvFHnVzo7' target='blank' className='hover-link'>  M142, Cactus B Block, 4th Floor, Tecci Park, OMR, Sholinganallur, Chennai 600 119</a>}
                />
              </div>
              <div className="col-md-4 mb-2">
                <Card
                  title="Get in touch"
                  img="phone.png"
                  text={
                    <>
                      <a href="mailto:contact@seionic.com" className='hover-link'>
                        contact@seionic.com
                      </a>
                      <br />
                      <a href="tel:+917299937663" className='hover-link'>
                        +91 7299937663
                      </a>
                    </>
                  }
                />
              </div>
              <div className="col-md-4 mb-2">
                <Card
                  title="Social Media"
                  img="linkedin.png"
                  text={
                    <>
                      <a
                        href="https://www.linkedin.com"
                        className='hover-link'
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        LinkedIn
                      </a>
                    </>
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="map-container">
        {/* Google Maps Embed */}
        <gmp-map
          center="12.910721778869629,80.22647857666016"
          zoom="14"
          map-id="DEMO_MAP_ID"
        >
          <gmp-advanced-marker
            position="12.910721778869629,80.22647857666016"
            title="My location"
          ></gmp-advanced-marker>
        </gmp-map>
      </div>
    </div>
    </div>
  );
}

export default ContactInfo;
